import React from "react";
import Background from "../../assets/platHitamPhone.jpeg"; // Ganti dengan gambar Plat Galvanil untuk mobile
import FotoHeader from "../../assets/plat_galbanil.jpg"; // Ganti dengan gambar Plat Galvanil untuk desktop

const Aplikasi = () => {
  const BgHeader = {
    backgroundImage: `url(${FotoHeader})`,
    backgroundSize: "cover",
    backgroundPosition: "40% 60%",
    overflow: "hidden",
  };

  return (
    <>
      {/* APLIKASI PC */}
      <section className="hidden sm:block">
        <h1 className="text-4xl container-screen text-primaryPandawa font-helvetica text-left">
          Aplikasi
        </h1>
        <section className="container-screen grid grid-cols-5 py-10">
          <div className="col-span-3">
            <div>
              <h2 className="text-left font-helvetica">1. Industri Otomotif</h2>
              <p className="text-justify mt-2">
                Plat Galvanil banyak digunakan dalam pembuatan panel bodi mobil
                karena kemampuannya yang sangat baik dalam menahan korosi dan
                daya lekat cat yang kuat. Material ini memberikan perlindungan
                jangka panjang dan kualitas pengecatan yang tinggi pada
                kendaraan.
              </p>

              <h2 className="text-left font-helvetica mt-12">
                2. Peralatan Rumah Tangga
              </h2>
              <p className="text-justify mt-2">
                Produk seperti oven, kulkas, dan mesin cuci sering memanfaatkan
                plat galvanil karena daya tahannya terhadap panas dan
                kelembapan, serta tampilannya yang bersih dan mudah dicat.
              </p>

              <h2 className="text-left font-helvetica mt-12">
                3. Panel Listrik dan Kabinet
              </h2>
              <p className="text-justify mt-2">
                Dalam bidang kelistrikan, plat galvanil digunakan untuk membuat
                panel distribusi listrik dan kabinet karena permukaannya yang
                keras, tahan karat, dan mudah dibentuk.
              </p>

              <h2 className="text-left font-helvetica mt-12">
                4. Industri Konstruksi
              </h2>
              <p className="text-justify mt-2">
                Plat galvanil digunakan dalam sistem rangka baja ringan, atap,
                dan dinding karena ketahanan korosinya dan kemudahan
                pemasangannya. Material ini memberikan perlindungan ekstra
                terhadap cuaca ekstrem dan kelembapan.
              </p>
            </div>
          </div>
          <div className="col-span-2 rounded-lg overflow-hidden ml-auto h-full w-1/2">
            <img src={Background} className="h-full w-full object-cover" />
          </div>
        </section>
      </section>

      {/* APLIKASI MOBILE */}
      <section className="sm:hidden" style={BgHeader}>
        <div className="bg-primaryPandawa/90 py-8">
          <div className="container-screen">
            <h1 className="font-helvetica text-white tracking-widest text-left text-2xl mb-10">
              APLIKASI
            </h1>
            <div className="text-left text-white">
              <h2 className="font-helvetica tracking-wider">
                1. Industri Otomotif
              </h2>
              <p className="font-montserrat text-justify mt-2">
                Plat Galvanil banyak digunakan dalam pembuatan panel bodi mobil
                karena kemampuannya yang sangat baik dalam menahan korosi dan
                daya lekat cat yang kuat. Material ini memberikan perlindungan
                jangka panjang dan kualitas pengecatan yang tinggi pada
                kendaraan.
              </p>

              <h2 className="font-helvetica tracking-wider mt-12">
                2. Peralatan Rumah Tangga
              </h2>
              <p className="font-montserrat text-justify mt-2">
                Produk seperti oven, kulkas, dan mesin cuci sering memanfaatkan
                plat galvanil karena daya tahannya terhadap panas dan
                kelembapan, serta tampilannya yang bersih dan mudah dicat.
              </p>

              <h2 className="font-helvetica tracking-wider mt-12">
                3. Panel Listrik dan Kabinet
              </h2>
              <p className="font-montserrat text-justify mt-2">
                Dalam bidang kelistrikan, plat galvanil digunakan untuk membuat
                panel distribusi listrik dan kabinet karena permukaannya yang
                keras, tahan karat, dan mudah dibentuk.
              </p>

              <h2 className="font-helvetica tracking-wider mt-12">
                4. Industri Konstruksi
              </h2>
              <p className="font-montserrat text-justify mt-2">
                Plat galvanil digunakan dalam sistem rangka baja ringan, atap,
                dan dinding karena ketahanan korosinya dan kemudahan
                pemasangannya. Material ini memberikan perlindungan ekstra
                terhadap cuaca ekstrem dan kelembapan.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Aplikasi;
